{
  "internalPortal": {
    "components": {
      "vsr": {
        "title": "VSR",
        "subTabs": {
          "dataEntry": "Data entry",
          "reportBuilder": "Report builder"
        },
        "dataEntry": {
          "vendorAndDateRange": {
            "title": "Vendor & date range",
            "description": "Select a vendor and date range to display bill streams across the organization",
            "vendor": "Vendor",
            "dateRange": "Date range",
            "currentMonth": "current mo"
          },
          "invoices": {
            "title": "Vendor invoices",
            "description": "Upload invoices to validate spend items or spend item groups for the selected period. Remember to link invoices to the relevant vendor accounts and the locations assigned to those vendor accounts.",
            "addDialog": {
              "description": "Choose how the invoice gets onto the bill stream."
            },
            "attachFromRepository": {
              "title": "Attach from documents repository",
              "informationMessage": "Select documents already in the organization repository to create invoices from them for this bill stream.",
              "actions": {
                "attachToBillStream": {
                  "label": "Attach to bill stream",
                  "ariaLabel": "Attach document to bill stream"
                },
                "detachFromBillStream": {
                  "label": "Detach from bill stream",
                  "ariaLabel": "Detach document from this bill stream",
                  "tooltip": "Detach document from this bill stream"
                },
                "displayOnlyAttached": "Display only attached documents",
                "attachedCount": "{{count}} documents attached to this bill stream",
                "attachedIndicator": {
                  "ariaLabel": "Document attached to this bill stream",
                  "tooltip": "Document attached to this bill stream"
                },
                "attachedToDifferentBillStream": {
                  "ariaLabel": "Document attached to different bill stream",
                  "tooltip": "Document attached to different bill stream"
                },
                "tooltips": {
                  "bulkAttachDisabledAlreadyAttached": "One or more selected documents are already attached to this bill stream.",
                  "bulkDetachDisabledNotAttached": "One or more selected documents are not attached to this bill stream."
                }
              },
              "table": {
                "columns": {
                  "attachedToThisBillStream": "Attached to this bill stream"
                }
              },
              "noData": {
                "title": "No documents found",
                "description": "No documents match the current filters."
              }
            }
          },
          "groups": {
            "title": "Monitor and continue validating spend item groups.",
            "description": "Monitor spend items and spend item groups for the selected vendor, continue the validation processes, and prepare the data entry needed to build the VSR report. Please note that you're validating spend item groups and spend items per expected bill.",
            "emptyState": "No location & AVA groups match the current filters.",
            "omittedValidation": {
              "label": "Omit validation",
              "tooltip": "Omit this location and affected vendor account from validation. All line items stay visible here and report as $0.00 savings with the reason.",
              "reasonLabel": "Reason for omitted validation",
              "reasonPlaceholder": "Billing error, SIB is investigating",
              "reasonRequired": "A reason is required to omit validation.",
              "dialogTitle": "Omit from validation",
              "dialogDescription": "This applies to every spend item for this location and affected vendor account. The reason is shown on the VSR in place of the entry.",
              "editReason": "Edit reason",
              "setSuccess": "Location and vendor account omitted from validation",
              "unsetSuccess": "Location and vendor account included in validation",
              "reasonSaved": "Omitted validation reason updated",
              "noItems": "There are no spend items to omit for this location and vendor account.",
              "lockedItems": "Every spend item in this group is locked on a VSR report and cannot be changed."
            }
          }
        },
        "reportBuilder": {
          "title": "Report builder",
          "createReport": "Create report",
          "createNextReport": "Create next report",
          "actions": {
            "createNewReport": "Create new report",
            "previousYear": "Previous year",
            "nextYear": "Next year",
            "createNextReport": "Create next report"
          },
          "fields": {
            "reportTitle": "Report title",
            "vsrDate": "VSR date",
            "vendorSavingsStartDate": "Vendor savings start date",
            "vendorSavingsEndDate": "Vendor savings end date",
            "savingsPeriod": "Savings period",
            "sibContract": "SIB contract",
            "spendCategories": "Spend categories",
            "locations": "Locations",
            "organizationWide": "Organization-wide",
            "allLocations": "All locations",
            "selectSpendCategoryFirst": "Select a spend category first"
          },
          "notifications": {
            "createSuccess": "Report created successfully",
            "createError": "Failed to create report",
            "copyError": "Couldn't load the report to copy",
            "deleteSuccess_one": "Report deleted",
            "deleteSuccess_other": "{{count}} reports deleted",
            "deleteError_one": "Failed to delete the report",
            "deleteError_other": "Failed to delete the reports"
          },
          "previewExtraction": {
            "title": "Report preview & extraction",
            "reportDetails": "Report details",
            "previewWithCount": "Preview ({{count}})",
            "download": {
              "pdf": "Full report (PDF)",
              "xlsx": "Full report (Excel)",
              "pageXlsx": "Current page (Excel)",
              "error": "Failed to download the report"
            },
            "documentPreview": {
              "title": "Report preview",
              "refresh": "Refresh PDF",
              "refreshError": "Failed to refresh the PDF",
              "outdated": "Notes changed. Refresh to see them in the PDF.",
              "error": {
                "title": "Couldn't load the report",
                "description": "Try again later or contact support if the problem persists"
              }
            },
            "notes": {
              "title": "Notes ({{count}})",
              "pageTitle": "Notes on page {{page}} ({{count}})",
              "showAll": "Show all notes",
              "emptyOnPage": "No notes on this page",
              "add": "Add note",
              "addingToPage": "Adding to page {{page}} ({{section}})",
              "noSection": "This page has no section to add notes to",
              "notInPdf": "Not in PDF",
              "hidden": "Hidden",
              "addError": "Failed to add note",
              "deleteError": "Failed to delete note",
              "updateError": "Failed to update note",
              "edit": "Edit note",
              "hideFromPdf": "Hide from PDF",
              "showInPdf": "Show in PDF",
              "sections": {
                "Summary": "Summary",
                "SibInvoiceByLocation": "SIB invoice by location",
                "SavingsByLocation": "Savings by location",
                "CategoryOverview": "Category overview",
                "CategoryDetail": "Category detail"
              },
              "page": "Page {{page}}",
              "empty": "No notes yet",
              "delete": "Delete note",
              "readOnly": "Notes can't be changed while the report is approved or sent."
            },
            "lockStatus": {
              "locked": "Locked"
            },
            "stageDialog": {
              "approveTitle": "Approve report?",
              "approveDescription": "Approving locks the report: it claims the spend line items and closes their invoices, so they can no longer be edited. Totals are calculated from the claimed lines.",
              "approveConfirm": "Approve",
              "unlockTitle": "Unlock report?",
              "unlockDescription": "Moving the report out of approved unlocks it, releases its spend line items and invoices, and resets its totals to zero. Only admins can do this.",
              "unlockConfirm": "Unlock"
            },
            "notifications": {
              "success": {
                "stage": "Report stage updated",
                "send": "Report sent",
                "update": "Report updated"
              },
              "error": {
                "stage": "Failed to update the report stage",
                "send": "Failed to send the report",
                "update": "Failed to update the report"
              }
            },
            "spendLineItems": {
              "title": "Spend line items included",
              "emptyTitle": "No spend line items in this report",
              "lockedTooltip": "The report is approved or sent, so its line items can't be changed",
              "columns": {
                "issueDate": "Issue date",
                "site": "Site",
                "vendor": "Vendor",
                "accountNumber": "Account number",
                "audit": "Audit",
                "charge": "Charge",
                "quantity": "Quantity",
                "oldRate": "Old rate",
                "newRate": "New rate",
                "oldTotal": "Old total",
                "newTotal": "New total",
                "savings": "Savings",
                "feeRate": "Fee rate",
                "fee": "Fee",
                "validationStatus": "Validation status"
              },
              "hideFromReport": "Hide from the report",
              "showInReport": "Show in the report",
              "claimedTooltip": "Claimed by another locked or sent report",
              "cannotHideTooltip": "This line item can't be hidden because it has no validation round",
              "notifications": {
                "hideSuccess": "Line item hidden from the report",
                "showSuccess": "Line item shown in the report",
                "toggleError": "Failed to update the line item"
              }
            },
            "editLockedHint": "Approved reports are locked. Change the stage to edit the details",
            "editSentHint": "Sent reports can't be edited",
            "sendDialog": {
              "title": "Send report?",
              "irreversibleTitle": "This can't be undone",
              "consequences": "After sending, the report details, stage and spend line items can no longer be changed, and the report can't be deleted.",
              "confirm": "Send report"
            }
          },
          "table": {
            "title": "Reports",
            "columns": {
              "reportTitle": "Report title",
              "vsrStage": "VSR stage",
              "vsrDate": "VSR date",
              "vendorSavingsStartDate": "Vendor savings start date",
              "vendorSavingsEndDate": "Vendor savings end date",
              "savingsPeriod": "Savings period",
              "spendCategories": "Spend categories",
              "locations": "Locations",
              "totalSavings": "Total savings"
            },
            "stages": {
              "built": "VSR built",
              "readyForReview": "VSR ready for review",
              "approved": "VSR approved",
              "sentToBilling": "VSR sent to billing platform"
            },
            "deleteDialog": {
              "title_one": "Deleting report",
              "title_other": "Deleting reports",
              "description_one": "Are you sure you want to remove this report? It won't be possible to restore it.",
              "description_other": "Are you sure you want to remove {{count}} reports? It won't be possible to restore them."
            },
            "noData": {
              "withFilters": {
                "title": "No reports match your filters",
                "description": "Try adjusting your filters to find what you're looking for"
              },
              "withoutFilters": {
                "title": "No reports found",
                "description": "Create a new report to get started"
              }
            }
          }
        },
        "filters": {
          "audits": "Audits",
          "location": "Location",
          "spendCategories": "Spend categories"
        }
      }
    }
  }
}
